import { z } from 'zod'

const cronFormFieldsSchema = z.object({
  description: z.string(),
  weekly_cron: z.string(),
  time: z.string(),
  name: z.string(),
  cron_id: z.string(),
  status: z.enum(['ACTIVE', 'INACTIVE']),
})

export type CronFormValues = z.infer<typeof cronFormFieldsSchema>

/** Add vs edit: controls in Angular have empty validators `[]` so form submit is never blocked on client side. */
export function createCronFormSchema(_isEdit: boolean) {
  return cronFormFieldsSchema
}

/** @deprecated Use `createCronFormSchema(isEdit)` — kept for tests defaulting to add rules. */
export const cronFormSchema = createCronFormSchema(false)

export function validateCronForm(values: CronFormValues, isEdit: boolean) {
  return createCronFormSchema(isEdit).safeParse(values)
}
